import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetGoldenChipsBalances = () => {
    const send = useGenericSend();

    return useCallback(() => send<Types.TGetGoldenChipsBalancesRequest, Types.IGoldenChipsBalancesResponseData>({
        ID: 32023,
        responses: [32024, 32025],
        description: 'Get Golden Chips Balances Request'
    }), [send]);
};
